import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader.tsx";
import { clearAuthSession } from "../../utils/sessionLogout.ts";

const LOGIN_PATH = "/login";

/**
 * Direct logout route (`/logout`). Runs the same session cleanup as the
 * navbar action, then redirects to the staff login. Works even when toasts
 * or overlays block the UI, because it does not depend on a clickable button.
 */
const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    clearAuthSession(dispatch);
    navigate(LOGIN_PATH, { replace: true });
  }, [dispatch, navigate]);

  return <Loader isLoading={true} />;
};

export default Logout;
